import { useState } from 'react';
import { useNavigate, useParams } from '@tanstack/react-router';
import { useAuthStore } from '../store/auth.ts';
import { dv } from '../i18n/dv.ts';

export function AcceptInvite(): JSX.Element {
  const navigate = useNavigate();
  const { token } = useParams({ from: '/invite/$token' });
  const reg = useAuthStore((s) => s.registerViaInvite);
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function submit(e: React.FormEvent): Promise<void> {
    e.preventDefault();
    setError(null);
    if (password !== confirm) {
      setError(dv.auth.passwordMismatch);
      return;
    }
    setPending(true);
    try {
      await reg(token, password, name);
      await navigate({ to: '/' });
    } catch {
      setError(dv.common.error);
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="mx-auto max-w-sm px-4 py-12">
      <h1 className="font-serif text-3xl tracking-tight mb-8">{dv.auth.acceptInviteTitle}</h1>
      <form className="space-y-3" onSubmit={submit}>
        <input
          className="input"
          placeholder={dv.auth.yourName}
          aria-label={dv.auth.yourName}
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <input
          className="input"
          type="password"
          dir="ltr"
          placeholder={dv.auth.newPassword}
          aria-label={dv.auth.newPassword}
          minLength={8}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <input
          className="input"
          type="password"
          dir="ltr"
          placeholder={dv.auth.confirmPassword}
          aria-label={dv.auth.confirmPassword}
          minLength={8}
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          required
        />
        {error && <p className="text-sm text-destructive" role="alert">{error}</p>}
        <button
          type="submit"
          disabled={pending}
          className="btn-primary w-full"
        >
          {pending ? dv.common.loading : dv.auth.acceptInvite}
        </button>
      </form>
    </div>
  );
}
